"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFreeCropParameter = exports.CollectionModelFreeCropParameterMutator = void 0;
const cropParameter_1 = require("./cropParameter");
class CollectionModelFreeCropParameterMutator extends cropParameter_1.CollectionModelCropParameterMutator {
    constructor(cropParameter) {
        super(cropParameter);
    }
    init(x, y, width, height) {
        this.cropParameter.cropParameterState.Mutator.create('free');
        this.setCrop(x, y, width, height);
    }
    setCrop(x, y, width, height) {
        const state = this.getValue();
        state.x = x;
        state.y = y;
        state.width = width;
        state.height = height;
        this.setValue(state);
    }
}
exports.CollectionModelFreeCropParameterMutator = CollectionModelFreeCropParameterMutator;
class CollectionModelFreeCropParameter extends cropParameter_1.CollectionModelCropParameter {
    constructor() {
        super(...arguments);
        this.tag = CollectionModelFreeCropParameter.TAG;
        this.Mutator = new CollectionModelFreeCropParameterMutator(this);
    }
    static state(id) {
        return {
            id,
            tag: 'free',
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    static isFree(t) {
        return t.tag === CollectionModelFreeCropParameter.TAG;
    }
    get x() {
        const state = this.state;
        return state.x;
    }
    get y() {
        const state = this.state;
        return state.y;
    }
    get width() {
        const state = this.state;
        return state.width;
    }
    get height() {
        const state = this.state;
        return state.height;
    }
}
exports.CollectionModelFreeCropParameter = CollectionModelFreeCropParameter;
CollectionModelFreeCropParameter.TAG = 'free';
//# sourceMappingURL=free.cropParameter.js.map